import { render, staticRenderFns } from "./NewMemberBoard.vue?vue&type=template&id=feea01e2&scoped=true"
import script from "./NewMemberBoard.vue?vue&type=script&lang=js"
export * from "./NewMemberBoard.vue?vue&type=script&lang=js"
import style0 from "./NewMemberBoard.vue?vue&type=style&index=0&id=feea01e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feea01e2",
  null
  
)

export default component.exports